import { object } from 'yup';

export const MODEL = {
  companyDescription: 'companyDescription',
  videoUrl: 'videoUrl',
};

export const validationSchema = t => object().shape({});
